import { css } from '@bts-web/utils-style-engine';
import { FC, PropsWithChildren } from 'react';

export const HiddenMobile: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`${css({
        hideBelow: 'lg',
      })} ${className ?? ''}`}
    >
      {children}
    </div>
  );
};
